import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { HistoricalService } from '../historical.service';
import { Group } from 'src/app/model/data-managemnt';
import { Platform, PopoverController } from '@ionic/angular';
import { DataManagementService } from '../../data-management/data-management.service';
import { Stop } from 'src/app/model/historical';
import { IonPullUpFooterState } from 'ionic-pullup';
import * as L from 'leaflet';
import Marker = L.Marker;
import Icon = L.Icon;
import { DatePipe } from '@angular/common';
import { StopModalComponent } from './stop-modal/stop-modal.component';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { Map } from 'leaflet';
import { GlobalService } from 'src/app/global.config';
import { GeocodingService } from 'src/app/utils/leaflet/service/geocoding.service';
import { LoadingService } from 'src/app/utils/loading/loadingService';
import { SigninService } from 'src/app/signin/signin.service';
import { version } from '../../../global.config';
import { StateService, ZoomState } from 'src/app/utils/leaflet/service/state.service';
import { RealtimeWorkerService } from 'src/app/pages/realtime/realtime-worker.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stop',
  templateUrl: './stop.component.html',
  styleUrls: ['./stop.component.scss'],
})
export class StopComponent implements OnInit {

  @ViewChild(StopModalComponent, { static: false }) stopModalComponent: StopModalComponent;

  AllStops: Subscription;
  selectedGroup: Group = new Group();
  stopClicked: Stop;
  stops: Stop[] = [];
  StopArray = [];
  footerState: IonPullUpFooterState;
  stopMap: Map;
  backButtonSubscription: Subscription;
  loading: boolean;
  version: string;

  constructor(
    public mapService: MapService,
    public historicalService: HistoricalService,
    private stateservice: StateService,
    private popoverController: PopoverController,
    public dataManagementService: DataManagementService,
    private platform: Platform,
    public signinService: SigninService,
    private globalService: GlobalService,
    private geocodingService: GeocodingService,
    public dataPipe: DatePipe,
    public loadingService: LoadingService,
    private realTimeWorker: RealtimeWorkerService,
    private translate: TranslateService,
  ) {
    this.footerState = IonPullUpFooterState.Collapsed;
    this.historicalService.selectedTab = 'stop';
    this.version = version;
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    const deviceId = this.dataManagementService.ensureSelectedVehicle()
      ? this.dataManagementService.getSelectedDeviceId()
      : null;
    if (!deviceId) {
      this.historicalService.stops = [];
      return;
    }
    if (this.historicalService.stopsLoadedForDeviceId === deviceId) {
      return;
    }

    this.loadStops(deviceId);
  }

  private loadStops(deviceId: number) {
    this.historicalService.stopsLoadedForDeviceId = deviceId;
    this.loading = true;
    const endDate = this.historicalService.endDate;
    const startDate = this.historicalService.startDate;
    this.historicalService.getAllStops(deviceId, { startDate, endDate }).subscribe(
      stops => {
        this.loading = false;
        this.historicalService.stops = this.historicalService.sortByDateDesc(stops, s => s.beginStopTime);
        this.historicalService.stops.forEach(stop => {
          stop.geocodingDetails = this.dataManagementService.getRelativePosition(
            stop.stopLatitude,
            stop.stopLongitude
          );
          stop.geocoding = stop.geocodingDetails;
          stop.beginStopTime = stop.beginStopTime;
          if (stop.geocodingDetails == null || stop.geocodingDetails == '') {
            this.geocodingService
              .inverseGeoconding(stop.stopLatitude, stop.stopLongitude, 17)
              .subscribe(
                adress => {
                  stop.geocoding = this.geocodingService.proccessingNomitamAddress(adress);
                  stop.geocodingDetails = stop.geocoding;
                },
                err => {
                  stop.geocodingDetails = null;
                  stop.geocoding = null;
                }
              );
          }
        });
      }
    );
  }

  ionViewDidEnter() {
    if (this.mapService.preventMapDestroy) {
      this.mapService.preventMapDestroy = false;
      setTimeout(() => {
        if (this.mapService.map) {
          this.mapService.map.invalidateSize();
          this.showVehicleMarkerWithoutFollow();
        }
      }, 150);
      return;
    }
    this.mapService.initMap(this.stopMap, 'stopMap');
    setTimeout(() => this.showVehicleMarkerWithoutFollow(), 200);
    this.expandFooterPanel();
  }

  /**
   * Keep the selected vehicle marker visible on the historique map,
   * but do NOT enable live follow (that causes the map to “glide”).
   */
  private showVehicleMarkerWithoutFollow(): void {
    const vehicule = this.dataManagementService.selectedVehicule;
    if (vehicule?.realTimeRecord) {
      this.realTimeWorker.updateMarker(vehicule, false, false);
    }
    this.realTimeWorker.trackingMode = false;
    this.stateservice.updateState(ZoomState.Manipulated);
  }

  ionViewWillLeave() {
    if (!this.mapService.preventMapDestroy && this.mapService.map) {
      this.mapService.map.remove();
    }
  }

  footerExpanded() {
    console.log('Footer expanded!');
  }

  footerCollapsed() {
    console.log('Footer collapsed!');
  }

  toggleFooter() {
    this.footerState =
      this.footerState === IonPullUpFooterState.Collapsed
        ? IonPullUpFooterState.Expanded
        : IonPullUpFooterState.Collapsed;
  }

  private expandFooterPanel(): void {
    setTimeout(() => {
      this.footerState = IonPullUpFooterState.Expanded;
    }, 600);
  }

  private searchPopoverOpen = false;

  async openPopover() {
    if (this.searchPopoverOpen) {
      return;
    }
    this.searchPopoverOpen = true;
    const popover = await this.popoverController.create({
      id: 'historique-search-popover',
      component: StopModalComponent,
      cssClass: 'historiquePopovers',
      alignment: 'center',
      backdropDismiss: true,
    });
    popover.onDidDismiss().then(() => {
      setTimeout(() => {
        this.searchPopoverOpen = false;
      }, 450);
    });
    await popover.present();
  }

  ngOnDestroy() {
    if (this.AllStops) {
      this.AllStops.unsubscribe();
    }
  }

  addStopToArray(stop: any, event: any) {
    if (!event.ctrlKey) {
      this.StopArray = [];
      this.mapService.removeMarkersFromMap();
    }

    this.StopArray.push(stop as never);
    this.drawStop(stop);
    this.footerState = IonPullUpFooterState.Collapsed;
  }

  StopSelected(stop: any) {
    return this.StopArray.indexOf(stop as never) !== -1;
  }

  drawStop(stop: Stop) {
    if (
      this.stopClicked == null ||
      this.stopClicked.beginStopTime != stop.beginStopTime
    ) {
      this.stopClicked = new Stop();
      this.stopClicked.beginStopTime = stop.beginStopTime;
      this.stopClicked.endStopTime = stop.endStopTime;
    }

    const lat = Number(stop.stopLatitude);
    const lng = Number(stop.stopLongitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return;
    }

    // Stop live vehicle follow so the map stays on this arrêt.
    this.realTimeWorker.trackingMode = false;

    const dateLabel = this.translate.instant('HISTORICAL.datearret');
    const durationLabel = this.translate.instant('HISTORICAL.dureearret');
    const placeLabel = this.translate.instant('HISTORICAL.lieuarret');
    const dateValue = this.dataPipe.transform(stop.beginStopTime, 'dd/MM/yyyy HH:mm:ss', 'en-US') || '—';
    const durationValue = stop.stopDurationStr || '—';
    const placeValue = stop.geocodingDetails || stop.geocoding || '—';

    const iconDate =
      `<svg class="stop-map-popup__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z"/></svg>`;
    const iconClock =
      `<svg class="stop-map-popup__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>`;
    const iconPin =
      `<svg class="stop-map-popup__icon" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>`;

    const popup =
      `<div class="stop-map-popup">` +
      `<div class="stop-map-popup__row">${iconDate}` +
      `<div><span class="stop-map-popup__label">${dateLabel}</span>` +
      `<span class="stop-map-popup__value">${dateValue}</span></div></div>` +
      `<div class="stop-map-popup__row">${iconClock}` +
      `<div><span class="stop-map-popup__label">${durationLabel}</span>` +
      `<span class="stop-map-popup__value">${durationValue}</span></div></div>` +
      `<div class="stop-map-popup__row">${iconPin}` +
      `<div><span class="stop-map-popup__label">${placeLabel}</span>` +
      `<span class="stop-map-popup__value">${placeValue}</span></div></div>` +
      `</div>`;

    const marker = new Marker({ lat, lng });
    marker.setIcon(
      new Icon({
        iconUrl: this.globalService.imagesDir + 'endMarker.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
      })
    );

    marker.bindPopup(popup, { className: 'stop-map-popup-wrap', maxWidth: 280 });

    marker.on('click', () => {
      this.focusMapOnStop(stop, marker);
    });

    marker.on('add', () => {
      marker.openPopup();
    });

    this.mapService.addMarker(marker);
    this.focusMapOnStop(stop, marker);
  }

  private focusMapOnStop(stop: Stop, marker?: Marker): void {
    const lat = Number(stop.stopLatitude);
    const lng = Number(stop.stopLongitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !this.mapService.map) {
      return;
    }

    this.realTimeWorker.trackingMode = false;
    this.stateservice.setSelectedMarker(stop);
    this.stateservice.updateState(ZoomState.Stop);

    // Exact position — no animation (avoids the small “glide”).
    this.mapService.map.setView([lat, lng], 17, { animate: false });
    setTimeout(() => {
      if (!this.mapService.map) {
        return;
      }
      this.mapService.map.invalidateSize({ pan: false });
      this.mapService.map.setView([lat, lng], 17, { animate: false });
      marker?.openPopup();
    }, 120);
  }
}
